export const customersPagesSelectors = customersData => customersData.pages;
